/* eslint-disable arrow-body-style */

import React from 'react';
import { useTranslation } from 'react-i18next';

// Custom
import modelIzlet from "@/models/izlet";
import modelIzletDan from '@/models/izlet_dan';
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import REGIzletForm from './Forms/REGIzletForm';
import { Permissions } from "@/lib/permissions";


const MyIzletiPage = () => {
  const { t } = useTranslation();

  return (
    <DataCentricPage
    needPermission={[Permissions.UserEdit]}

    primaryModel={modelIzlet}
    primaryTitleToken="titles.izleti_moji"
    primaryView="korisnik"
    primaryAllowAdd
    primaryAddLabel={t('titles.izlet_new') as string}
    primaryDialogInsertForm='korisnik'
    primaryAllowView
    primaryDialogForm="korisnik"
    primaryDialogComponent={REGIzletForm}
    primaryAllowEdit
    // primaryAllowGeneratePDF
    // primaryAllowShareIzlet
    primaryAllowGenerateVodickiObrazac={false}
    primaryOverrideAPIUrl="reg/izleti"
    primaryExportLabel="buttons.export_xlsx_izleti"

    secondaryModel={modelIzletDan}
    secondaryTitleToken='titles.plan_izleta'
    secondaryView="korisnik"
    secondaryAllowView={false}
    
    baseRecordPath="reg/izleti"
    childRecordRelativePath='dani'
    geomRelativePath="geom"
    
    mapId={10}
    mapModel={modelIzlet}
  />
  );
};

export default MyIzletiPage;
